<div class="layout-container">
  <app-sidebar [class.sidebar-active]="isMenuOpen"></app-sidebar>

  @if (isMenuOpen) {
    <div class="layout-overlay" (click)="toggleMenu()"></div>
  }

  <div class="layout-main">
    <header class="layout-topbar">
      <p-toolbar class="mobile-centered-toolbar">
        <ng-template #start>
          <div class="topbar-start">
            <button class="menu-button" (click)="toggleMenu()">
              <i class="pi pi-bars"></i>
            </button>

            <div class="welcome-container">
              <h1 class="welcome-text">
                {{ greeting }}
                @if (welcomeName()) {
                  ,
                  <div class="highlight">{{ welcomeName() }}</div>
                }

                @if (building(); as selectedBuilding) {
                  <div class="address-wrapper">
                    <i class="pi pi-map-marker"></i>
                    {{ selectedBuilding.tenantAddress }}
                  </div>
                }
              </h1>
            </div>
          </div>
        </ng-template>

        <ng-template #end>
          <div class="topbar-end-actions">
            @if (showAddPhonePrompt()) {
              <a
                class="add-phone-cta"
                routerLink="/abonado"
                aria-label="Añade tu teléfono para activar comunicaciones telemáticas"
              >
                <i class="pi pi-phone" aria-hidden="true"></i>
                <span class="add-phone-cta__label"
                  >No has completado tu configuración, activa las comunicaciones electrónicas</span
                >
              </a>
            }
            <button class="btn notifications-btn pt-2" routerLink="/notificaciones">
              @if ($notification.unreadCount() > 0) {
                <p-overlaybadge severity="danger">
                  <i class="pi pi-bell"></i>
                </p-overlaybadge>
              } @else {
                <i class="pi pi-bell"></i>
              }
            </button>
          </div>
        </ng-template>
      </p-toolbar>
    </header>

    <main class="layout-content bg-light" style="height: stretch">
      <router-outlet></router-outlet>
    </main>
  </div>

  @if (showWelcomeTour()) {
    <app-welcome-tour [features]="tourFeatures()" (finished)="completeWelcomeTour()" />
  }
</div>
